/* jc-page-headings.js — JC-EVO 09/25/2026: text pages design B (default page template + /policies/*). Loaded with defer by
   layout/theme.liquid on those pages only. Progressive enhancement: page content is never edited or moved.
   1. A paragraph that is only a short bold line followed by regular body text (how most RKIN pages type their section
      titles, e.g. <p><strong>Communications</strong></p>) keeps its element and gets class "jc-h" (h2 look, from the
      design B CSS block) plus role="heading" aria-level="2", so screen readers get the page structure.
      Conservative: 2-80 characters, starts with a capital or digit, contains a letter, no link/image/line break/control,
      no sentence punctuation mid-line, does not end in . , ; or :, is not a notice/instruction line (Note, Warning,
      Caution, Important, Attention, Please, Do not, Never, Always ...), every visible character bold, next block has
      regular (non-bold) text,
      and only plain wrappers (no list, table, quote or classed element) between it and the content container.
   2. A paragraph holding only spaces / &nbsp; gets class "jc-blank" (hidden by the CSS; Shopify policies open with one).
   Content that is custom HTML or an embed (style, script, iframe, form, classed divs) is left alone entirely. */
(function () {
  'use strict';
  var ROOTS = '#MainContent[data-template="page"] .page-content rte-formatter, .shopify-policy__body .rte';
  var CUSTOM = 'style, script, iframe, form, object, embed, div[class]:not(.rte-table-wrapper)';
  var WS = /[\s\u00a0\u200b]+/g;
  var NOTICE = /^(note|notice|warning|caution|important|attention|please|do not|don['\u2019]t|never|always)\b/i;
  function text(el) { return (el.textContent || '').replace(WS, ' ').trim(); }
  function blank(el) { return el.tagName === 'P' && !text(el) && !el.querySelector(':not(br)'); }
  // every non-blank text node sits inside <strong>/<b> within el
  function allBold(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n, seen = false;
    while ((n = w.nextNode())) {
      if (!n.nodeValue.replace(WS, '')) continue;
      var b = n.parentElement && n.parentElement.closest('strong, b');
      if (!b || !el.contains(b)) return false;
      seen = true;
    }
    return seen;
  }
  function plainPath(p, root) {
    for (var e = p.parentElement; e && e !== root; e = e.parentElement) {
      if (e.tagName !== 'DIV' || e.hasAttribute('class') || e.hasAttribute('role')) return false;
    }
    return e === root;
  }
  function nextBlock(p) {
    var n = p.nextElementSibling;
    while (n && (n.tagName === 'BR' || blank(n))) n = n.nextElementSibling;
    return n;
  }
  function headingLike(p) {
    if (p.hasAttribute('class') || p.hasAttribute('role')) return false;
    if (p.querySelector('a, img, br, input, button, select, textarea, svg, video, iframe, [class]')) return false;
    var t = text(p);
    if (t.length < 2 || t.length > 80 || !/[A-Za-z]/.test(t)) return false;
    if (/[.,;:]$/.test(t) || /[.!?;:]\s/.test(t)) return false;
    if (!/^[A-Z0-9]/.test(t) || NOTICE.test(t)) return false;
    return allBold(p);
  }
  function bodyAfter(p) {
    var n = nextBlock(p);
    return !!n && /^(P|UL|OL|DIV)$/.test(n.tagName) && !!text(n) && !allBold(n);
  }
  function run(root) {
    if (root.hasAttribute('data-jc-headings') || root.querySelector(CUSTOM)) return;
    root.setAttribute('data-jc-headings', '');
    var ps = root.querySelectorAll('p');
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      if (!plainPath(p, root)) continue;
      if (blank(p)) { p.classList.add('jc-blank'); continue; }
      if (headingLike(p) && bodyAfter(p)) {
        p.classList.add('jc-h');
        p.setAttribute('role', 'heading');
        p.setAttribute('aria-level', '2');
      }
    }
  }
  var roots = document.querySelectorAll(ROOTS);
  for (var r = 0; r < roots.length; r++) {
    try { run(roots[r]); } catch (e) { /* enhancement only: the page stays as served */ }
  }
})();
